import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'

import { Tooltip } from '@mui/material'
import { util } from '../../../util'
import useQuery from '../../../hooks/useQuery'
import { useLocation } from 'react-router-dom'

import './styles.css'

function AxFooter(props) {
  const { className, footer: _footer } = props
  const [footer, setFooter] = useState(util.isObject(_footer) ? _footer : {})
  const { footer_left_block: _fContent, footer_sections: _fSections } = footer
  const fContent = util.isObject(_fContent) ? _fContent : {}
  const fSections = Array.isArray(_fSections) ? _fSections : []
  const {
    description: fContentDescription, home_icon: fContentLogo, social_media_links: _fContentIcons, title: fContentTitle
  } = fContent
  const { url: fContentLogoUrl } = util.isObject(fContentLogo) ? fContentLogo : {}
  const fContentIcons = Array.isArray(_fContentIcons) ? _fContentIcons : []
  const RightBox = (props) => {
    const { className, canExpand } = props

    return (
      <div className={clsx('right-box', className)}>
        {fSections.map((section, idx) => {
          const { id, footer_links: _links, title, __expand: expand } = util.isObject(section) ? section : {}
          const links = Array.isArray(_links) ? _links : []

          return (
            <div className='link-box' key={id}>
              {title
                ? (
                  <div className='title' onClick={canExpand ? handleExpandLinkBox(idx) : null}>
                    <div>{title}</div>

                    <div className='indicator'>{expand ? '-' : '+'}</div>
                  </div>
                )
                : null}

              <div className={clsx('links', expand ? 'expand' : '')}>
                {links.map((link) => {
                  const { id, href, label, target } = util.isObject(link) ? link : {}

                  return label
                    ? <div className='link' key={id}><a href={href || '/coming-soon'} target={target || '_self'}>{label}</a></div>
                    : null
                })}
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  const query = useQuery()
  const location = useLocation()

  const handleExpandLinkBox = (idx) => () => {
    const { __expand: expand } = fSections[idx]
    fSections[idx].__expand = typeof expand === 'boolean' ? !expand : true
    footer.footer_sections = [].concat(fSections)
    setFooter({ ...footer })
  }

  const isHideFooter = () => {
    if (location.pathname === '/coming-soon') {
      if (query.get("tab") && query.get("tab") > 0) return true
    }

    return false
  }

  useEffect(() => {
    const { footer: _footer } = props
    setFooter(util.isObject(_footer) ? _footer : {})
  }, [props])

  return (
    <div className={clsx('ax-footer', className)}>
      {
        !isHideFooter() ? (
          <div className='content-box'>
            <div className='left-box'>
              <div className='logo-box'>
                <img className='img' alt='' src={fContentLogoUrl ? process.env.REACT_APP_BASE_URL + fContentLogoUrl : '/icon/logo.svg'} />
                {/* <img className='img' alt='' src={fContentLogoUrl ? 'http://axolot.oceannexus.my:1337' + fContentLogoUrl : '/icon/logo.svg'} /> */}
              </div>

              {fContentTitle ? <div className='title'>{fContentTitle}</div> : null}

              {fContentDescription ? <div className='description'>{fContentDescription}</div> : null}

              <div className='icons'>
                {fContentIcons.map((icon) => {
                  const { id, icon: _icon, label } = util.isObject(icon) ? icon : {}
                  let iicon = Array.isArray(_icon) ? _icon[0] || {} : {}
                  iicon = typeof iicon === 'object' ? iicon : {}
                  const { url: iconUrl } = iicon

                  return (
                    <div className='icon-box' key={id}>
                      <a href={label || '/coming-soon'} target="_blank">
                        <Tooltip arrow placement='bottom' title={label || ''}>
                          <img className='img' alt={label || ''} src={process.env.REACT_APP_BASE_URL + iconUrl} />
                          {/* <img className='img' alt={label || ''} src={'http://axolot.oceannexus.my:1337' + iconUrl} /> */}
                        </Tooltip>
                      </a>
                    </div>
                  )
                })}
              </div>
            </div>

            <RightBox />

            <RightBox className='mobile' canExpand />
          </div>
        ) : null
      }

      <div className='copyright'>Copyright (c) 2021 Tech Creatures Sdn. Bhd. All Rights Reserved.</div>
    </div>
  )
}

AxFooter.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  data: PropTypes.object
}

export default AxFooter
